import { render, staticRenderFns } from "./TaxBasis.vue?vue&type=template&id=5d922788&scoped=true"
import script from "./TaxBasis.vue?vue&type=script&lang=js"
export * from "./TaxBasis.vue?vue&type=script&lang=js"
import style0 from "./TaxBasis.vue?vue&type=style&index=0&id=5d922788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d922788",
  null
  
)

export default component.exports